export const GET_ALL = 'GET_ALL'
export const CREATE = 'CREATE'
export const EDIT = 'EDIT'
export const DEL = 'DEL'
export const DEL_ALL = 'DEL_ALL'